


























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { firestore } from "firebase/app";
import {
  FirestoreCollectionUpdater,
  FirestoreSortInfo,
  FirestoreFilter,
  WithID
} from "@/firestoreUpdater";
import CollectionUpdater from "@/components/CollectionUpdater.vue";

export type TableHeader<T = any> = {
  text: string;
  value: keyof WithID<T>;
  align?: "left" | "center" | "right";
  sortable?: boolean;
  class?: string[] | string;
  width?: string;
};

@Component({ components: { CollectionUpdater } })
export default class CollectionTable<Item extends object> extends Vue {
  protected readonly pageSizeItems = [5, 10, 25, { text: "All", value: -1 }];
  @Prop() dbRef!: firestore.CollectionReference;
  @Prop() filter?: FirestoreFilter<Item>[];
  @Prop() headers?: TableHeader<Item>[];
  protected pageSize = 5;
  protected updater: CollectionUpdater<Item> | null = null;
  protected loading = true;
  protected items: WithID<Item>[] = [];
  protected prevReady = false;
  protected nextReady = false;
  protected sort: FirestoreSortInfo<Item> | null = null;

  previousPage() {
    this.updater && this.updater.previousPage();
  }

  nextPage() {
    this.updater && this.updater.nextPage();
  }

  @Watch("updater")
  @Watch("items")
  updatePages() {
    this.prevReady = Boolean(
      this.updater && this.updater.updater && this.updater.updater.previousPage
    );

    this.nextReady = Boolean(
      this.updater && this.updater.updater && this.updater.updater.nextPage
    );
  }

  sortHandler(
    items: WithID<Item>[],
    index: string & keyof Item,
    isDescending: boolean
  ): WithID<Item>[] {
    // Setting this.sort triggers a refresh; avoid a loop
    if (
      !this.sort ||
      this.sort.key != index ||
      this.sort.ascending == isDescending
    ) {
      this.sort = { key: index, ascending: !isDescending };
    }
    return items;
  }
}
